export default __webpack_public_path__ + "static/media/student_bg.bfe779e0.jpg";